import { useTranslation } from "react-i18next";
import { Grid } from "semantic-ui-react";

import { DATE_FORMATS_FNS } from "components";
import { KIOSK_COMMUNICATION_EVENT_TYPES } from "models";
import { EventInfo } from "modules/AppointmentDetails/components/KioskCommunicationLog/components";
import { formatDate } from "utils/dateHelperFunctions";

import type { TFunction } from "i18next";
import type { KioskCommunication, KioskCommunicationEvent } from "models";

const getEventName = (event: KioskCommunicationEvent, t: TFunction) => {
  switch (event.type) {
    case KIOSK_COMMUNICATION_EVENT_TYPES.CheckInOpened:
      return t("v8_opened", "Opened");

    case KIOSK_COMMUNICATION_EVENT_TYPES.CheckInAnswered:
      return t("v8_answered", "Answered");

    case KIOSK_COMMUNICATION_EVENT_TYPES.LabelDetached:
      return t("v8_kiosk_key_label_detached", "Kiosk key label detached");

    default:
      return "";
  }
};

type CommunicationEventsProps = {
  comm: KioskCommunication;
  events?: KioskCommunicationEvent[];
};

export const CommunicationEvents = ({ events, comm }: CommunicationEventsProps) => {
  const { t } = useTranslation();

  if (!events?.length) return null;

  return (
    <div className="kiosk-comm-section-container">
      <div className="kiosk-comm-section-header">{t("v8_kiosk_communication_events", "Kiosk Communication Events")}</div>

      <Grid>
        {events.map((event, key) => {
          return (
            <Grid.Row key={key} className="section-rows">
              <Grid.Column width={12}>{getEventName(event, t)}</Grid.Column>

              <Grid.Column width={4} className="event-timestamp">
                {formatDate(event.created_on, DATE_FORMATS_FNS.hoursMinutes)} - {formatDate(event.created_on, DATE_FORMATS_FNS.dateMonthYear)}
              </Grid.Column>

              <EventInfo comm={comm} event={event} />
            </Grid.Row>
          );
        })}
      </Grid>
    </div>
  );
};
